export default {
  app: {
    env: process.env.MIX_APP_ENV || "local",
    name: process.env.MIX_APP_NAME,
    debug: process.env.MIX_APP_DEBUG === "true" || false,
    yoshidaTop: process.env.MIX_YOSHIDA_TOP_URL,
    jstreamUrl: process.env.MIX_JSTREAM_SRC_URL,
    noneLogoEventId: process.env.MIX_NONE_LOGO_EVENT_ID
  },
  socket: {
    url: process.env.MIX_SOCKET_SERVER_HOST,
    port: process.env.MIX_SOCKET_SERVER_PORT,
    connection: `${process.env.MIX_SOCKET_SERVER_HOST}:${process.env.MIX_SOCKET_SERVER_PORT}`
  },
  storage: {
    secret: process.env.MIX_STORAGE_SECRET || "vVn,Lpb%ejy)z#^seUL*}Zn2cY.vqYdtiuFewA!+RFW.]ywDN*",
    settings: "settings",
    tab: "tab",
    videoDeviceId: "videoDeviceId",
    micDeviceId: "micDeviceId"
  }
}
